import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function WhatYouGet() {
  const items = [{
    title: 'Guía SOS Sueño Infantil',
    desc: '(PDF de lectura rápida).'
  }, {
    title: 'El Paso a Paso de las 72 Horas',
    desc: 'Cómo pasar de brazos a cuna sin trauma.'
  }, {
    title: 'Mapa de Ventanas de Sueño',
    desc: 'La tabla exacta para acostarlo en el momento dulce.'
  }, {
    title: 'Protocolo de Ambiente Hipnótico',
    desc: 'Para maximizar la melatonina.'
  }, {
    title: 'Guía de Crisis y Regresiones',
    desc: 'Para no dar ni un paso atrás.'
  }, {
    title: 'Checklist de Auditoría del Cuarto',
    desc: 'Prepara el entorno perfecto.'
  }];
  return <section className="bg-cream py-24 px-6 md:px-12" data-id="element-141">
      <div className="max-w-6xl mx-auto" data-id="element-142">
        <FadeIn data-id="element-143">
          <h2 className="text-4xl md:text-5xl text-center mb-16" data-id="element-144">
            Todo lo que incluye tu guía
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-145">
          {items.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-146">
              <div className="bg-white p-8 rounded-3xl shadow-sm border border-brown/5 h-full hover:shadow-md transition-shadow" data-id="element-147">
                <CheckCircle2 className="w-8 h-8 text-periwinkle mb-6" data-id="element-148" />
                <h3 className="text-xl font-bold mb-3" data-id="element-149">{item.title}</h3>
                <p className="text-brown/70" data-id="element-150">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}